export default __webpack_public_path__ + "static/media/nip_2.a7aa0e67.jpg";